import axios from "axios";

let tenantId = localStorage.getItem("tenantId")


const formatErrorResponse = () => {
    let responseObj = {}
    responseObj.success = false;
    responseObj.message = "Failed to submit. Please try again"
    return responseObj
}
const formatSuccessResponse = (response) => {
    let responseObj = {}
    if (typeof response.data === "string") {
        responseObj.success = false;
        responseObj.message = response.data;
        responseObj.data = []
    } else {
        responseObj.success = true;
        responseObj.data = response.data;
    }
    return responseObj
}


export const getSpaceNotification = async (spaceId) => {
    let responseObj = { status: "", message: "", data: {} }
    try {
        let res = await axios({
            method: "GET",
            url: `${process.env.REACT_APP_BACKEND_API}/notification`,
            params: {
                spaceId: spaceId,
            },
            headers: {
                "Content-Type": "application/json",
                userId: "1",
                tenantId: tenantId
            },
        });
        responseObj = formatSuccessResponse(res)
    } catch (error) {
        responseObj.success = false;
        responseObj.message = "Failed to submit. Please try again"
    }
    return responseObj

}

export const notificationEditData = async (notificationId, spaceId) => {
    let responseObj = { status: "", message: "", data: {} }
    try {
        let res = await axios({
            method: "GET",
            url: `${process.env.REACT_APP_BACKEND_API}/notification/${notificationId}`,
            params: {
                spaceId: spaceId,
            },
            headers: {
                "Content-Type": "application/json",
                userId: "1",
                tenantId: tenantId
            },
        });
        responseObj = formatSuccessResponse(res)
    } catch (error) {
        responseObj.success = false;
        responseObj.message = "Failed to submit. Please try again"
    }
    return responseObj
};

export const updateNotification = async (spaceId, notificationData) => {
    let responseObj = { status: "", message: "", data: {} }
    try {
        let res = await axios({
            method: "PUT",
            url: `${process.env.REACT_APP_BACKEND_API}/notification`,
            params: {
                spaceId: spaceId,
            },
            data: notificationData,
            headers: {
                "Content-Type": "application/json",
                userId: "1",
                tenantId: tenantId
            },
        });
        responseObj = formatSuccessResponse(res)
    } catch (error) {
        responseObj = formatErrorResponse()
    }
    return responseObj
};


